import awsConfig from '../aws-exports';

/**
 * Determines the environment based on AWS Amplify configuration
 * This aligns with the git branch:
 * - main branch uses production Amplify environment → returns 'production'
 * - other branches use staging/development Amplify environment → returns 'development'
 *
 * @returns 'production', 'staging' or 'development'
 */
export function getEnvironment(): 'production' | 'development' | 'staging' {
  // Check if the AWS config contains production domains
  // Production domains won't have 'staging' in them
  const configStr = JSON.stringify(awsConfig).toLowerCase();

  // If the config contains 'staging', it's the development environment
  if (configStr.includes('staging')) {
    return 'staging';
  }

  if (configStr.includes('development')) {
    return 'development';
  }

  // Otherwise, assume production
  return 'production';
}
